var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocuments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_812",
    "data-name": "Group 812",
    transform: "translate(-9918 22784)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_263",
    "data-name": "Ellipse 263",
    cx: 125,
    cy: 125,
    r: 125,
    transform: "translate(9918 -22784)",
    fill: "#fbfbfb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_800",
    "data-name": "Group 800",
    transform: "translate(9541.893 -23047.305)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_980",
    "data-name": "Path 980",
    d: "M523.075,340.809a14.045,14.045,0,0,1-14.046,14.043h-72.3a14.045,14.045,0,0,1-14.046-14.043",
    transform: "translate(48.844 88.649)",
    fill: "#e2e5ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_981",
    "data-name": "Path 981",
    d: "M428.546,299.425s-18.472,45.6-13.286,69.963,6.008,28.318,5.681,35.234-2.689,21.073-8.727,20.237c-3.428-.477-6.809-4.877-6.809-4.877l-.875-4.933.109-5.817-.845-100.541,2.922-4.948,7.525-3.213,7.631-.727Z",
    transform: "translate(12.097 8.148)",
    fill: "#e2e5ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_982",
    "data-name": "Path 982",
    d: "M440.2,359.859H400.52a2.945,2.945,0,0,1,0-5.89H440.2a2.945,2.945,0,0,1,0,5.89Z",
    transform: "translate(0 114.248)",
    fill: "#2f4265"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_983",
    "data-name": "Path 983",
    d: "M536.586,359.859H434.228a2.945,2.945,0,1,1,0-5.89H536.586a2.945,2.945,0,1,1,0,5.89Z",
    transform: "translate(65.569 114.248)",
    fill: "#2f4265"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_984",
    "data-name": "Path 984",
    d: "M441.128,359.859H421.371a2.945,2.945,0,1,1,0-5.89h19.756a2.945,2.945,0,0,1,0,5.89Z",
    transform: "translate(40.56 114.248)",
    fill: "#2f4265"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_985",
    "data-name": "Path 985",
    d: "M510.973,446.449h-72.3a17.008,17.008,0,0,1-16.988-16.991V312.227a17.008,17.008,0,0,1,16.988-16.991h72.3a17.01,17.01,0,0,1,16.991,16.991V429.458A17.01,17.01,0,0,1,510.973,446.449Zm-72.3-145.323a11.111,11.111,0,0,0-11.1,11.1V429.458a11.111,11.111,0,0,0,11.1,11.1h72.3a11.114,11.114,0,0,0,11.1-11.1V312.227a11.114,11.114,0,0,0-11.1-11.1Z",
    transform: "translate(46.901)",
    fill: "#2f4265"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_986",
    "data-name": "Path 986",
    d: "M443.461,429.02H416.189a13.409,13.409,0,0,1-13.395-13.392V312.192A13.407,13.407,0,0,1,416.189,298.8h32.126v5.89H416.189a7.51,7.51,0,0,0-7.5,7.5V415.628a7.512,7.512,0,0,0,7.5,7.5h27.273Z",
    transform: "translate(10.152 6.933)",
    fill: "#2f4265"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1198",
    "data-name": "Rectangle 1198",
    width: 66.733,
    height: 5.89,
    transform: "translate(489.728 332.774)",
    fill: "#2f4265"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1199",
    "data-name": "Rectangle 1199",
    width: 66.733,
    height: 5.89,
    transform: "translate(489.728 352.53)",
    fill: "#2f4265"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1200",
    "data-name": "Rectangle 1200",
    width: 66.733,
    height: 5.89,
    transform: "translate(489.728 372.067)",
    fill: "#2f4265"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1201",
    "data-name": "Rectangle 1201",
    width: 25.684,
    height: 5.89,
    transform: "translate(427.356 345.287)",
    fill: "#2f4265"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1202",
    "data-name": "Rectangle 1202",
    width: 25.684,
    height: 5.89,
    transform: "translate(427.356 365.043)",
    fill: "#2f4265"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1203",
    "data-name": "Rectangle 1203",
    width: 25.684,
    height: 5.89,
    transform: "translate(427.356 384.58)",
    fill: "#2f4265"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1204",
    "data-name": "Rectangle 1204",
    width: 66.733,
    height: 5.89,
    transform: "translate(489.728 411.361)",
    fill: "#2f4265"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuments);
export default __webpack_public_path__ + "static/media/documents.85b4468c63941660c564910688b308a3.svg";
export { ForwardRef as ReactComponent };